import React from "react";
import usePageTitle from "../hooks/use-page-title";

function PageTitle(props) {

    const title = usePageTitle();

    return title || null;
}

export default PageTitle;
